<template>
  <button class="Drop-Menu-Item Drop-Menu-Item--red" @click="toLogoutOpen">Выйти</button>
</template>

<script setup>
  import {useStore} from 'vuex';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  //---------------------------------
  const store = useStore();
  const emit = defineEmits(['close-menu']);
  //---------------------------------
  //Открыть окно подтверждения Logout
  const toLogoutOpen = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.LOGOUT_CONFIRM);
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.auth);
    sendEmitClose();
  }
  //Отправляем событие закрытие дропдауна
  const sendEmitClose = () => emit('close');
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>
